import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layouts from "../layouts/Layouts";
import Slider from "react-slick";
import { db } from "../firebase";
import { ImEye } from "react-icons/im";
import { FiChevronsRight } from "react-icons/fi";
import { collection, query, limit, getDocs, orderBy } from "firebase/firestore";
import { heroSlider } from "../layouts/sliderProps";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import AppointmentForm from "../components/Appointment";
import { fetchServices } from "../locales/services";
import { useRefContext } from "../components/ScrollToAppointment";
import { storage } from "../firebase";
import { listAll, ref } from "firebase/storage";
import { getDownloadURL } from "firebase/storage";
import ReviewsSection from "../components/Reviews";
import { GiHealthIncrease } from "react-icons/gi";
import EyeDonationExperience from "../components/EyeDonationSection";
import MyopiaSection from "../components/MyopiaSection";
import MyopiaSlider from "../components/MyopiaSlider";
import MyopiaCenter from "../components/MyopiaCenter";
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
  }, []);

  return isMobile;
};
const Home = () => {
  const [blogs, setBlogs] = useState([]);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mediaUrls, setMediaUrls] = useState({
    heroImages: "",
    aboutImage: "",
    iconicImage: "",
    testimonialBackgrounds: [],
    appointmentImage: "",
    eyeDonationDoctor: "",
    eyeDonationHindi: "",
    eyeDonationGujarati: "",
    eyeDonateIcon: "",
  });

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const homeRef = ref(storage, "home");
        const listResult = await listAll(homeRef);

        const urls = await Promise.all(
          listResult.items.map((item) => getDownloadURL(item))
        );

        console.log("Fetched Firebase URLs:", urls);

        setMediaUrls({
          heroImage1: urls.find((url) =>
            url.includes("ophthalmologist-examining")
          ),
          heroImage2: urls.find((url) =>
            url.includes("woman-getting-eye-exam")
          ),
          centerImage: urls.find((url) => url.includes("VNU_M701_19")),
          aboutImage: urls.find((url) => url.includes("2024-10-17")),
          iconicImage: urls.find((url) => url.includes("iconic")),
          testimonial1: urls.find((url) =>
            url.includes("patient-ophthalmologist")
          ),
          testimonial2: urls.find((url) => url.includes("doctor-preparing")),
          testimonialBackgrounds: urls.filter((url) =>
            url.includes("testimonial")
          ),
          appointmentImage: urls.find((url) => url.includes("appointment")),

          eyeDonationDoctor: urls.find((url) =>
            url.includes("donation-contact")
          ),
          eyeDonationHindi: urls.find((url) => url.includes("donation-hindi")),
          eyeDonationGujarati: urls.find((url) =>
            url.includes("donation-gujarati")
          ),
          eyeDonateIcon: urls.find((url) => url.includes("3881259-200")),
          myopiaInfo: urls.find((url) => url.includes("myopia-info")),
        });
      } catch (error) {
        console.error("Error fetching media: ", error);
      }
    };

    fetchMedia();
  }, []);

  console.log("mediaURLS", services);

  const handleBlogClick = (blogItem) => {
    navigate("/blog-details", { state: { blogItem } });
  };
  useEffect(() => {
    const loadServices = async () => {
      try {
        const fetchedServices = await fetchServices();
        setServices(fetchedServices.slice(0, 4));
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        setLoading(false);
      }
    };

    loadServices();
  }, []);

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        const blogRef = collection(db, "blogs");

        const q = query(blogRef, orderBy("createdAt", "desc"), limit(3));
        const querySnapshot = await getDocs(q);
        const blogData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setBlogs(blogData);
      } catch (error) {
        console.error("Error fetching blogs: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const { t, i18n } = useTranslation();
  const truncateText = (text, length = 127) => {
    if (text.length > length) {
      return text.substring(0, length) + "...";
    }
    return text;
  };
  const handleServiceClick = (service) => {
    if (!service) {
      navigate("/services");
    } else
      navigate("/service-details", {
        state: { service },
        serviceId: service.sortOrder,
      });
  };

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const homeRef = ref(storage, "home");
        const listResult = await listAll(homeRef);

        const urls = await Promise.all(
          listResult.items.map((item) => getDownloadURL(item))
        );

        setMediaUrls((prevState) => ({
          ...prevState,
          heroImage1: urls.find((url) =>
            url.includes(
              "ophthalmologist-examining-woman-with-optometrist-trial-frame-female-patient-check-vision-ophthalmological-clinic"
            )
          ),
          heroImage2: urls.find((url) =>
            url.includes("woman-getting-eye-exam")
          ),
          centerImage: urls.find((url) => url.includes("VNU_M701_19")),
          aboutImage: urls.find((url) => url.includes("2024-10-17")),
          iconicImage: urls.find((url) => url.includes("iconic")),
          testimonial1: urls.find((url) =>
            url.includes("patient-ophthalmologist-s-office_23")
          ),
          testimonial2: urls.find((url) =>
            url.includes("doctor-preparing-ophthalmologist-s-office_23")
          ),
          testimonialBackgrounds: urls.filter((url) =>
            url.includes("testimonial")
          ),
          appointmentImage: urls.find((url) => url.includes("appointment")),
        }));
      } catch (error) {
        console.error("Error fetching images: ", error);
      }
    };

    fetchImages();
  }, []);

  const { appointmentRef } = useRefContext();

  return (
    <Layouts footer={2} noheader>
      <>
        {/*====== Hero Area Start ======*/}
        {/* TOP CAROUSEL SECTION */}
        <section className="hero-slider hero-slider-two style-two">
          <Slider {...heroSlider} className="hero-slider-active">
            <div className="single-hero-slider">
              <div
                className="hero-slider-bg bg-size-cover"
                style={{
                  backgroundImage: "url(assets/img/home/2.jpg)",
                  width: "100%",
                  height: "940px",
                  padding: 0,
                }}
                alt="Hero Slide 1"
              />
              <div className="container">
                <div className="row">
                  <div className="col-lg-9 col-md-9">
                    <div className="hero-content">
                      <span
                        className="tagline"
                        data-animation="fadeInDown"
                        data-delay="0.5s"
                      >
                        {t("home.bannerTitle1")}
                      </span>
                      <h1
                        className="title"
                        data-animation="fadeInLeft"
                        data-delay="0.6s"
                      >
                        {t("home.bannerTitleBig1")}
                      </h1>
                      {/* EXPLORE SERVICES BUTTON */}
                      <Link
                        to="/services"
                        className="template-btn template-btn-bordered"
                        data-animation="fadeInUp"
                        data-delay="0.7s"
                      >
                        {t("header.exploreServices")} <FiChevronsRight />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="single-hero-slider">
              <div
                className="hero-slider-bg bg-size-cover"
                style={{
                  backgroundImage: "url(assets/img/home/5.jpeg)",
                  width: "100%",
                  height: "940px",
                }}
              />
              <div className="container">
                <div className="row">
                  <div className="col-lg-9 col-md-9">
                    <div className="hero-content">
                      <h1
                        className="title"
                        style={{ fontSize: "80px" }}
                        data-animation="fadeInLeft"
                        data-delay="0.6s"
                      >
                        {t("home.bannerTitle5")}
                      </h1>
                      <div style={{ marginTop: "20px", width: "690px" }}>
                        <span
                          className="tagline"
                          style={{ display: "block" }}
                          data-animation="fadeInDown"
                          data-delay="0.5s"
                        >
                          {t("home.bannerTitleBig5")}
                        </span>

                        <Link
                          to="/equipments"
                          className="template-btn template-btn-bordered"
                          data-animation="fadeInUp"
                          data-delay="0.7s"
                          style={{ display: "inline-block", marginTop: "10px" }}
                        >
                          {t("header.knowmore")} <FiChevronsRight />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="single-hero-slider">
              <div
                className="hero-slider-bg bg-size-cover"
                style={{
                  backgroundImage: "url(assets/img/home/1.jpg)",
                  width: "100%",
                  height: "940px",
                }}
              />
              <div className="container">
                <div className="row">
                  <div className="col-lg-9 col-md-9">
                    <div className="hero-content">
                      <span
                        className="tagline"
                        data-animation="fadeInDown"
                        data-delay="0.5s"
                      >
                        {t("home.bannerTitle2")}
                      </span>
                      <h1
                        className="title"
                        data-animation="fadeInLeft"
                        data-delay="0.6s"
                      >
                        {t("home.bannerTitleBig2")}
                      </h1>
                      {/* CONTACT BUTTON: LEADING SOLUTIONS */}
                      <Link
                        to="/contact"
                        className="template-btn template-btn-bordered"
                        data-animation="fadeInUp"
                        data-delay="0.7s"
                      >
                        {t("header.contact")} <FiChevronsRight />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>{" "}
            <div className="single-hero-slider">
              <div
                className="hero-slider-bg bg-size-cover"
                style={{
                  backgroundImage: "url(assets/img/home/12.jpg)",
                  width: "100%",
                  height: "940px",
                }}
              />
              <div className="container">
                <div className="row">
                  <div className="col-lg-9 col-md-9">
                    <div className="hero-content">
                      <span
                        className="tagline"
                        data-animation="fadeInDown"
                        data-delay="0.5s"
                      >
                        {t("home.bannerTitle3")}
                      </span>
                      <h1
                        className="title"
                        data-animation="fadeInLeft"
                        data-delay="0.6s"
                      >
                        {t("home.bannerTitleBig3")}
                      </h1>
                      <a
                        href="/contact"
                        className="template-btn template-btn-bordered"
                        data-animation="fadeInUp"
                        data-delay="0.7s"
                      >
                        {t("header.contact")} <FiChevronsRight />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="single-hero-slider">
              <div
                className="hero-slider-bg bg-size-cover"
                style={{
                  backgroundImage: "url(assets/img/home/3.jpg)",
                  width: "100%",
                  height: "940px",
                }}
              />
              <div className="container">
                <div className="row">
                  <div className="col-lg-9 col-md-9">
                    <div className="hero-content">
                      {/* <span
                        className="tagline"
                        data-animation="fadeInDown"
                        data-delay="0.5s"
                      >
                        {t("home.bannerTitle4")}
                      </span> */}
                      <h1
                        className="title"
                        data-animation="fadeInLeft"
                        data-delay="0.6s"
                      >
                        {t("home.insurancetitle")}
                      </h1>
                      <a
                        href="#insurance"
                        className="template-btn template-btn-bordered"
                        data-animation="fadeInUp"
                        data-delay="0.7s"
                      >
                        {t("header.knowmore")} <FiChevronsRight />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Slider>

          <div className="hero-slider-arrow" />
        </section>{" "}
        <section className="feature-section pharmacy-feature">
          <div className="container wow fadeInUp" data-wow-delay="0.3s">
            <div className="row no-gutters justify-content-center feature-loop">
              <div className="col-lg-4 col-md-6 col-sm-10">
                <div className="iconic-box-three">
                  <div className="icon">
                    <i className="flaticon-medicine" />
                  </div>
                  <h4 className="title">{t("home.bannerBox1")}</h4>
                  <p>{t("home.bannerBoxDescription1")}</p>
                  <Link to="/services" className="box-link">
                    {t("home.bannerBoxButton1")} <FiChevronsRight />
                  </Link>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-10">
                <div
                  className="iconic-box-three featured-box"
                  style={{ borderRadius: "6px", backgroundColor: "red" }}
                >
                  <div className="icon">
                    <i className="flaticon-stethoscope" color="" />
                  </div>
                  <h4 className="title">{t("home.bannerBox2")}</h4>
                  <p>{t("home.bannerBoxDescription2")}</p>
                  <Link to="/doctor" className="box-link">
                    {t("home.bannerBoxButton2")} <FiChevronsRight />
                  </Link>
                  <span className="big-icon">
                    <i className="flaticon-stethoscope" />
                  </span>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-10">
                <div className="iconic-box-three">
                  <div className="icon">
                    <i className="flaticon-flask" />
                  </div>
                  <h4 className="title">{t("home.bannerBox3")}</h4>
                  <p>{t("home.bannerBoxDescription3")}</p>
                  <Link to="/equipments" className="box-link">
                    {t("home.bannerBoxButton3")} <FiChevronsRight />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="about-section section-gap">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-7 col-md-10">
                <div className="bordered-icon-wrapper">
                  <img
                    src={mediaUrls.aboutImage}
                    alt="About Dr. Lakdawala Eye Hospital"
                    srcSet={`${mediaUrls.aboutImage}?alt=media&token=low_quality 300w, ${mediaUrls.aboutImage}?alt=media&token=high_quality 800w`}
                    sizes="(max-width: 768px) 300px, 800px"
                  />
                  <div className="border-icon">
                    <ImEye style={{ color: "var(--color-secondary)" }} />
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-9">
                <div className="about-content">
                  <div className="section-heading mb-35">
                    <span className="tagline">{t("home.aboutHospital")}</span>
                    <h2 className="title">{t("home.aboutTitle")}</h2>
                    <p>{t("home.aboutExperience")}</p>
                  </div>
                  <p>{t("home.aboutDescription")}</p>
                  <Link to="/about" className="template-btn mt-40">
                    {t("home.learnMore")}
                    <FiChevronsRight />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section-gap" style={{}}>
          {/* Content Header */}
        </section>
        {/* Enhanced Video Experience */}
        <EyeDonationExperience mediaUrls={mediaUrls} i18n={i18n} t={t} />
        {/* Call to Action */}
        <section className="service-section bg-color-fourth section-gap-top">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-10">
                <div className="section-heading heading-white text-center mb-70">
                  <span className="tagline">{t("home.popularServices1")}</span>
                  <h2 className="title">{t("home.popularServices2")} </h2>
                </div>
              </div>
            </div>
            <div className="iconic-boxes-big-image">
              <div className="row justify-content-lg-between justify-content-center first-row">
                <div
                  className="col-xl-3 col-lg-4 col-md-6 col-sm-8 first-column"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div
                    className="single-iconic-item wow fadeInRight"
                    data-wow-delay="0.4s"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "100%",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 30px rgba(0, 0, 0, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                    onClick={() => handleServiceClick()}
                  >
                    <div className="icon">
                      <i className="flaticon-eye" />
                    </div>
                    <h4 className="title">
                      <div href="#">{t("home.service1Title")}</div>
                    </h4>
                    <p>{t("home.service1Description")}</p>
                  </div>
                </div>
                <div
                  className="col-xl-3 col-lg-4 col-md-6 col-sm-8 second-column"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div
                    className="single-iconic-item wow fadeInLeft"
                    data-wow-delay="0.4s"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "100%",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 30px rgba(0, 0, 0, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                    onClick={() => handleServiceClick()}
                  >
                    <div className="icon">
                      <i className="flaticon-eye" />
                    </div>
                    <h4 className="title">
                      <div href="#"> {t("home.service2Title")}</div>
                    </h4>
                    <p>{t("home.service2Description")}</p>
                  </div>
                </div>
              </div>

              <div className="row justify-content-lg-between justify-content-center second-row">
                <div
                  className="col-xl-3 col-lg-4 col-md-6 col-sm-8 first-column"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div
                    className="single-iconic-item wow fadeInLeft"
                    data-wow-delay="0.5s"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "100%",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 30px rgba(0, 0, 0, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                    onClick={() => handleServiceClick()}
                  >
                    <div className="icon">
                      <i className="flaticon-eye" />
                    </div>
                    <h4 className="title">
                      <div href="#"> {t("home.service3Title")}</div>
                    </h4>
                    <p>{t("home.service3Description")}</p>
                  </div>
                </div>
                <div
                  className="col-xl-3 col-lg-4 col-md-6 col-sm-8 second-column"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div
                    className="single-iconic-item wow fadeInRight"
                    data-wow-delay="0.5s"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "100%",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 30px rgba(0, 0, 0, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 15px rgba(0, 0, 0, 0.1)";
                    }}
                    onClick={() => handleServiceClick()}
                  >
                    <div className="icon">
                      <i className="flaticon-eye" />
                    </div>
                    <h4 className="title">
                      <div href="#"> {t("home.service4Title")}</div>
                    </h4>
                    <p>{t("home.service4Description")}</p>
                  </div>
                </div>
              </div>

              <img
                src={mediaUrls.centerImage}
                className="big-image"
                style={{
                  width: "100%",
                  height: "700px",
                  objectFit: "contain",
                }}
                alt="Dr. Lakdawala Eye Hospital"
              />
              <img
                src="assets/img/iconic-box/border-line.png"
                alt="Dr. Lakdawala Eye Hospital"
                className="border-image"
              />
            </div>
          </div>
        </section>
        <section className="feature-section section-gap bg-color-grey">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="section-heading text-center mb-40">
                  <span className="tagline">{t("home.technologyUsed")} </span>
                  <h2 className="title">{t("home.technologyUsed2")} </h2>
                </div>
              </div>
            </div>
            <div className="row justify-content-center service-loop">
              {!loading ? (
                services.slice(0, 4).map((service, index) => (
                  <div
                    key={index}
                    className="col-lg-3 col-md-6 col-sm-8"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "stretch",
                      minHeight: "320px",
                      marginTop: "20px",
                    }}
                  >
                    <div
                      className="iconic-box-two mt-30 wow fadeInUp"
                      data-wow-delay={`${0.3 + index * 0.1}s`}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        height: "100%",
                        alignItems: "center",
                        cursor: "pointer",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                      }}
                      onClick={() => handleServiceClick(service)}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.05)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 20px rgba(0, 0, 0, 0.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 2px 10px rgba(0, 0, 0, 0.1)";
                      }}
                    >
                      <div className="icon">
                        <i className="flaticon-eye" />
                      </div>
                      <h4
                        className="title"
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          minHeight: "40px",
                          flexShrink: 0,
                        }}
                      >
                        <Link to={service.link}>
                          {" "}
                          {t(
                            `servicesPage.service${service.sortOrder}.${service?.title}`
                          )}
                        </Link>{" "}
                        {/* Dynamic title */}
                      </h4>
                      <p style={{ flexGrow: 1, marginBottom: "20px" }}>
                        {truncateText(
                          t(
                            `servicesPage.service${service.sortOrder}.${service?.description}`
                          ),
                          100
                        )}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <div>Loading...</div>
              )}
            </div>
          </div>
        </section>
        {/* <section className="section-gap bg-color-white" id="insurance">
          <div className="container" style={{ margin: "auto" }}>
            <div className="row justify-content-center">
              <InsuranceComponent />
            </div>
          </div>
        </section> */}
        {/* insurance section */}
        <section className="about-section section-gap" id="insurance">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div
                className="col-lg-5 col-md-9"
                style={{ marginBottom: "100px" }}
              >
                {/* <span className="tagline">{t("home.aboutHospital")}</span> */}
                <div className="about-content">
                  <div className="section-heading mb-35">
                    <h2 className="title">{t("home.insurancetitle")}</h2>
                  </div>
                  <p>{t("home.insurancedescription")}</p>
                </div>
              </div>
              <div className="col-lg-7 col-md-10">
                <div className="insurance-icon-wrapper">
                  <div className="insurance-icon">
                    <GiHealthIncrease
                      style={{ color: "var(--color-secondary)" }}
                    />
                  </div>
                  <img
                    src="/assets/img/home/insurance.jpeg"
                    alt="About Dr. Lakdawala Eye Hospital"
                    srcSet="/assets/img/home/insurance.jpeg"
                    sizes="(max-width: 768px) 300px, 800px"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <ReviewsSection />
        <AppointmentForm ref={appointmentRef} imageNumber="4" />
        {/* <MyopiaSection mediaUrls={mediaUrls} /> */}
        {/*  <MyopiaSlider heroSlider={heroSlider} /> */}
        <MyopiaCenter mediaUrls={mediaUrls} />
        <section className="latest-blog-section latest-blog-section-bg section-gap bg-color-secondary-10">
          <div className="container">
            <div className="row justify-content-lg-end justify-content-center">
              <div className="col-lg-6 col-md-10 col-sm-11">
                <div className="row">
                  <div className="col-xl-10 col-lg-12 col-md-10">
                    <div className="section-heading mb-60">
                      <span className="tagline"> {t("home.newsTitle1")}</span>
                      <h2 className="title">{t("home.newsTitle2")}</h2>
                    </div>
                  </div>
                </div>
                <div>
                  {blogs.map((blog, index) => (
                    <div
                      key={blog.id}
                      data-wow-delay={`${0.3 + index * 0.1}s`}
                      onClick={() => handleBlogClick(blog)}
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        padding: "20px",
                        border: "1px solid #ddd",
                        marginBottom: "10px",
                        transition: "all 0.3s ease",
                        backgroundColor: "transparent",
                        position: "relative",
                        cursor: "pointer",
                        borderRadius: "8px",
                        boxShadow: "none",
                        minHeight: "200px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "white";
                        e.currentTarget.style.boxShadow =
                          "0px 4px 15px rgba(0, 0, 0, 0.1)";
                        e.currentTarget.style.borderColor = "none";

                        const readMoreButton =
                          e.currentTarget.querySelector(".read-more-btn");
                        if (readMoreButton) {
                          readMoreButton.style.opacity = "1";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.boxShadow = "none";
                        e.currentTarget.style.borderColor = "#ddd";

                        const readMoreButton =
                          e.currentTarget.querySelector(".read-more-btn");
                        if (readMoreButton) {
                          readMoreButton.style.opacity = "0";
                        }
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flex: 4,
                          paddingRight: "15px",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ marginBottom: "10px" }}>
                          <div
                            href="#"
                            className="blog-date"
                            style={{ color: "var(--color-doctor)" }}
                          >
                            <i className="far fa-calendar-alt" />{" "}
                            {new Date(
                              blog.createdAt.seconds * 1000
                            ).toLocaleDateString()}
                          </div>
                        </div>
                        <h4
                          style={{
                            margin: "10px 0",
                            fontSize: "22px",
                          }}
                        >
                          <Link
                            href={`/blog-details/${blog.id}`}
                            style={{ textDecoration: "none" }}
                          >
                            <div>{blog.title}</div>
                          </Link>
                        </h4>
                        {/* The Read More button will be hidden by default */}
                        <Link
                          className="read-more-btn"
                          style={{
                            padding: "2px 4px",
                            width: "100%",
                            textDecoration: "underline",
                            fontSize: "14px",
                            borderRadius: "2px",
                            opacity: "0",
                            transition: "opacity 0.5s ease",
                          }}
                        >
                          Read More
                        </Link>
                      </div>

                      {blog.images && blog.images[0] && (
                        <div
                          style={{
                            flex: 2,
                            marginLeft: "15px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "4px",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={
                              blog.images[0] + "?alt=media&token=low_quality"
                            }
                            srcSet={`${blog.images[0]}?alt=media&token=low_quality 300w, ${blog.images[0]}?alt=media&token=high_quality 800w`}
                            sizes="(max-width: 768px) 300px, 800w"
                            alt="Blogs at Dr. Lakdawala Eye Hospital"
                            style={{
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div
            className="section-bg d-none d-lg-block"
            style={{
              backgroundImage: "url(assets/img/section-bg/1.jpg)",
            }}
          />
        </section>
      </>
    </Layouts>
  );
};

export default Home;
